import commonType from '../common/commonType'
export default {
  /**
   * 获取分辨率及缩放比设置Zoom
   * @returns {string}
   */
  getZoom () {
    let setZoom = parseFloat((1 / window.devicePixelRatio).toFixed(6))
    let pixel = parseFloat((window.screen.width * window.devicePixelRatio / 1920).toFixed(2))
    return (setZoom * pixel).toFixed(2)
  },
  // 根据生日获取年龄
  getAgeByBirth (birthDate) {
    let result = ''
    let currentYear = new Date().getFullYear()
    let calculationYear = new Date(birthDate).getFullYear()
    let wholeTime = currentYear + birthDate.substring(4)
    let calculationAge = currentYear - calculationYear
    // 判断是否过了生日
    if (new Date().getTime() < new Date(wholeTime).getTime()) {
      calculationAge = calculationAge - 1
    }
    if (isNaN(calculationAge)) {
    } else {
      result = calculationAge
    }

    return result
  },
  // 获取性别
  getGender (gender) {
    if (gender === '0') {
      return '未知性别'
    } else if (gender === '1') {
      return '男性'
    } else if (gender === '2') {
      return '女性'
    } else if (gender === '9') {
      return '未说明性别'
    } else {
      return gender
    }
  },
  getSex (sex) {
    if (sex === '0') {
      return '女性'
    } else if (sex === '1') {
      return '男性'
    } else if (sex === '8') {
      return '未知'
    } else if (sex === '9') {
      return '未说明性别'
    } else {
      return sex
    }
  },
  // 获取户籍性质
  getHouseHoldType (houseHoldType) {
    if (houseHoldType === '1') {
      return '本市-本区'
    } else if (houseHoldType === '2') {
      return '本市-外区'
    } else if (houseHoldType === '3') {
      return '外地'
    } else if (houseHoldType === '9') {
      return '其他'
    } else {
      return houseHoldType
    }
  },
  // 获取政治面貌
  getPolitical (politicalStatus) {
    let political = commonType.getPoliticalArr().find(r => r.id === politicalStatus)
    if (political) {
      return political.name
    } else {
      return politicalStatus
    }
  },
  // 获取宗教
  getReligion (religion) {
    if (religion === '1') {
      return '无'
    } else if (religion === '2') {
      return '佛教'
    } else if (religion === '3') {
      return '道教'
    } else if (religion === '4') {
      return '伊斯兰教'
    } else if (religion === '5') {
      return '基督教'
    } else if (religion === '6') {
      return '天主教'
    } else if (religion === '7') {
      return '其他宗教'
    } else if (religion === '9') {
      return '不详'
    } else {
      return religion
    }
  },
  // 获取文化程度
  getEducation (educationalLevel) {
    let education = commonType.getEducationArr().find(r => r.id === educationalLevel)
    if (education) {
      return education.name
    } else {
      return educationalLevel
    }
  },
  // 获取照护等级
  getCareLevel (careLevel) {
    let care = commonType.getCareLevelArr().find(r => r.id === careLevel)
    if (care) {
      return care.name
    } else {
      return careLevel
    }
  },
  // 获取老人类别
  getAdmissionPersonnelType (admissionPersonnelType) {
    let type = commonType.getAdmissionPersonnelTypeArr().find(r => r.id === admissionPersonnelType)
    if (type) {
      return type.name
    } else {
      return admissionPersonnelType
    }
  },
  // 获取特长
  getSpecial (strongPoint) {
    let special = commonType.getSpecialArr().find(r => r.id === strongPoint)
    if (special) {
      return special.name
    } else {
      return strongPoint
    }
  },
  // 获取老人类型
  getOldPersonType (oldPersonType) {
    let type = commonType.getOldPersonTypeArr().find(r => r.id === oldPersonType)
    if (type) {
      return type.name
    } else {
      return oldPersonType
    }
  },
  // 获取付费方式
  getPaymentStatus (paymentStatusCode) {
    if (paymentStatusCode === 1) {
      return '公费'
    } else if (paymentStatusCode === 2) {
      return '半自费(部分享受养老服务补贴)'
    } else if (paymentStatusCode === 3) {
      return '自费'
    } else if (paymentStatusCode === 9) {
      return '不详'
    } else {
      return paymentStatusCode
    }
  },
  // 经济来源
  getEconomic (economic) {
    let economicObj = commonType.getEconomicArr().find(r => r.id === economic)
    if (economic) {
      return economicObj.name
    } else {
      return economic
    }
  },
  // 养老保障情况
  getAnnuityGuarantee (annuityGuarantee) {
    let annuity = commonType.getAnnuityGuaranteeArr().find(r => r.id === annuityGuarantee)
    if (annuity) {
      return annuity.name
    } else {
      return annuityGuarantee
    }
  },
  // 医疗保障情况
  getMedicalGuarantee (medicalGuarantee) {
    let medical = commonType.getMedicalGuaranteeArr().find(r => r.id === medicalGuarantee)
    if (medical) {
      return medical.name
    } else {
      return medicalGuarantee
    }
  },
  // 病例
  getDiseaseSlow (diseaseSlow) {
    let slow = commonType.getDiseaseSlowArr().find(r => r.id === diseaseSlow)
    if (slow) {
      return slow.name
    } else {
      return diseaseSlow
    }
  },
  getDiseaseHeart (diseaseHeart) {
    let heart = commonType.getDiseaseHeartArr().find(r => r.id === diseaseHeart)
    if (heart) {
      return heart.name
    } else {
      return diseaseHeart
    }
  },
  getDiseasePressSure (diseasePressSure) {
    let pressSure = commonType.getDiseasePressSureArr().find(r => r.id === diseasePressSure)
    if (pressSure) {
      return pressSure.name
    } else {
      return diseasePressSure
    }
  },
  getDiseaseBrain (diseaseBrain) {
    let brain = commonType.getDiseaseBrainArr().find(r => r.id === diseaseBrain)
    if (brain) {
      return brain.name
    } else {
      return diseaseBrain
    }
  },
  getDiseaseFat (diseaseFat) {
    let fat = commonType.getDiseaseFatArr().find(r => r.id === diseaseFat)
    if (fat) {
      return fat.name
    } else {
      return diseaseFat
    }
  },
  getDiseaseBreath (diseaseBreath) {
    let breath = commonType.getDiseaseBreathArr().find(r => r.id === diseaseBreath)
    if (breath) {
      return breath.name
    } else {
      return diseaseBreath
    }
  },
  getDiseaseAlimentary (diseaseAlimentary) {
    let alimentary = commonType.getDiseaseAlimentaryArr().find(r => r.id === diseaseAlimentary)
    if (alimentary) {
      return alimentary.name
    } else {
      return diseaseAlimentary
    }
  },
  getDiseaseMetabolism (diseaseMetabolism) {
    let metabolism = commonType.getDiseaseMetabolismArr().find(r => r.id === diseaseMetabolism)
    if (metabolism) {
      return metabolism.name
    } else {
      return diseaseMetabolism
    }
  },
  getDiseaseBone (diseaseBone) {
    let bone = commonType.getDiseaseBoneArr().find(r => r.id === diseaseBone)
    if (bone) {
      return bone.name
    } else {
      return diseaseBone
    }
  },
  getDiseaseSpecial (diseaseSpecial) {
    let special = commonType.getDiseaseSpecialArr().find(r => r.id === diseaseSpecial)
    if (special) {
      return special.name
    } else {
      return diseaseSpecial
    }
  },
  getDiseaseHealthy (diseaseHealthy) {
    let healthy = commonType.getDiseaseHealthyArr().find(r => r.id === diseaseHealthy)
    if (healthy) {
      return healthy.name
    } else {
      return diseaseHealthy
    }
  },
  /**
   * 计算时间差
   * @param startTime
   * @param endTime
   * @param diffType
   * @returns {number}
   */
  getDateDiff (startTime, endTime, diffType) {
    // 将计算间隔类性字符转换为小写
    diffType = diffType.toLowerCase()
    let sTime = new Date(startTime)
    let eTime = new Date(endTime)
    // 作为除数的数字
    let timeType = 1
    switch (diffType) {
      case 'second':
        timeType = 1000
        break
      case 'minute':
        timeType = 1000 * 60
        break
      case 'hour':
        timeType = 1000 * 3600
        break
      case 'day':
        timeType = 1000 * 3600 * 24
        break
      default:
        break
    }
    return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType))
  },
  // 时间差
  getTimeDifference (date1, date2) {
    let startTime = new Date(date1) // 开始时间
    let endTime = new Date(date2) // 结束时间
    let usedTime = endTime - startTime // 相差的毫秒数
    let days = Math.floor(usedTime / (24 * 3600 * 1000)) // 计算出天数
    let leavel = usedTime % (24 * 3600 * 1000) // 计算天数后剩余的时间
    let hours = Math.floor(leavel / (3600 * 1000)) // 计算剩余的小时数
    let leavel2 = leavel % (3600 * 1000) // 计算剩余小时后剩余的毫秒数
    let minutes = Math.floor(leavel2 / (60 * 1000)) // 计算剩余的分钟数
    return days === 0 ? hours + '时' + minutes + '分' : days + '天' + hours + '时' + minutes + '分'
  },
  // 时间差 时分秒
  calculateTimeDifference (date1) {
    let startTime = new Date(date1) // 开始时间
    let endTime = new Date() // 结束时间
    let usedTime = endTime - startTime // 相差的毫秒数
    const seconds = Math.floor(usedTime / 1000) // 将毫秒数转换为秒
    const hours = Math.floor(seconds / 3600) // 将秒转换为时分秒格式
    const minutes = Math.floor((seconds - (hours * 3600)) / 60)
    // const remainingSeconds = seconds % 60
    // return hours === 0 ? (minutes === 0 ? `${remainingSeconds}秒` : `${minutes}分${remainingSeconds}秒`) : `${hours}时${minutes}分${remainingSeconds}秒`
    return hours === 0 ? (minutes === 0 ? `刚刚` : `${minutes}分`) : `${hours}时${minutes}分`
  },
  // 判断周几
  getWeekDay (dateString) {
    let weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    let date = new Date(dateString)
    let dayOfWeek = date.getDay()
    return weekdays[dayOfWeek]
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js